import React from 'react'
import styled from 'styled-components'
import { formatArticleDate } from '../../../helpers/date'
import compareDates from '../../../helpers/compareDates'
import TypographyAtom from '../../atoms/typography/typography'

const Container = styled.div`
  display: grid;
  gap: 4px;

  &.article-page {
    display: grid;
    gap: 4px;
    width: auto;
    align-content: end;

    p {
      text-align: right;
    }
  }

  @media only screen and (min-width: 48em) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    &.recent-secondary-article {
      display: grid;
    }
  }
`

function ArticleDate({
  inCard,
  reducedSize,
  updatedDate,
  publishedDate,
  updatedDateLabel,
  publishedDateLabel,
  articleAuthor,
}) {
  const laterDate =
    !updatedDate || !publishedDate
      ? updatedDate || publishedDate
      : compareDates({ iso1: updatedDate, iso2: publishedDate })
  const formatedDate = laterDate && formatArticleDate(laterDate)
  const dateType = {
    [updatedDate || 'empty']: updatedDateLabel,
    [publishedDate || 'empty']: publishedDateLabel,
  }

  if (inCard) {
    return (
      <Container className={reducedSize ? 'recent-secondary-article' : ''}>
        <TypographyAtom
          type="P"
          weight="Regular"
          color="Orange"
          copy={`${dateType[laterDate]} ${formatedDate}`}
        />
        {articleAuthor && (
          <TypographyAtom type="P" weight="Regular" color="Orange" copy={articleAuthor} />
        )}
      </Container>
    )
  }

  return (
    <Container className="article-page">
      <TypographyAtom
        type="P"
        weight="Regular"
        color="Orange"
        copy={`${dateType[laterDate]} ${formatedDate}`}
      />
      {articleAuthor && (
        <TypographyAtom type="P" weight="Regular" color="Orange" copy={articleAuthor} />
      )}
    </Container>
  )
}

export default ArticleDate
